import {
    dateSelectOptions,
    invoicesAmountOperatorOptions,
} from './invoicesSortAndFilters';
import moment from 'moment-timezone';

export const preConfiguredFilters = {
    ALL_CREDITS: 'All credits',
};

export const creditsTableFilterOptions = [
    // { label: 'All open invoices', value: 'Open' },
    { label: 'All credits', value: preConfiguredFilters.ALL_CREDITS },
];

export const creditsSortByOptions = [
    { label: 'Credit number', value: 'Credit number' },
    { label: 'Customer code', value: 'Customer code' },
    { label: 'Customer name', value: 'Company name' },
    { label: 'Credit created date', value: 'Credit created date' },
    { label: 'Credit available date', value: 'Credit available date' },
    { label: 'Amount available', value: 'Amount available' },
    { label: 'Original total', value: 'Original total' },
];

export const creditsAmountType = [
    { label: 'Available', value: 'Available' },
    { label: 'Original', value: 'Total' },
];

const {
    THIS_MONTH,
    NEXT_MONTH,
    LAST_MONTH,
    LAST_7_DAYS,
    LAST_30_DAYS,
    NEXT_7_DAYS,
    NEXT_30_DAYS,
    CREATE_DATE_ATB_CURRENT,
    CREATE_DATE_ATB_30_DAYS,
    CREATE_DATE_ATB_60_DAYS,
    CREATE_DATE_ATB_90_PLUS_DAYS,
    AVAILABLE_DATE_ATB_NOT_AVAILABLE,
    AVAILABLE_DATE_ATB_CURRENT,
    AVAILABLE_DATE_ATB_30_DAYS,
    AVAILABLE_DATE_ATB_60_DAYS,
    AVAILABLE_DATE_ATB_90_PLUS_DAYS,
    CUSTOM_DATE_RANGE,
    CUSTOM_DAYS_RANGE,
} = dateSelectOptions;

export const creditsCreatedSinceOptions = [
    THIS_MONTH,
    LAST_MONTH,
    LAST_7_DAYS,
    LAST_30_DAYS,
    CREATE_DATE_ATB_CURRENT,
    CREATE_DATE_ATB_30_DAYS,
    CREATE_DATE_ATB_60_DAYS,
    CREATE_DATE_ATB_90_PLUS_DAYS,
    CUSTOM_DATE_RANGE,
    CUSTOM_DAYS_RANGE,
];

export const creditsAvailableSinceOptions = [
    THIS_MONTH,
    NEXT_MONTH,
    LAST_MONTH,
    LAST_7_DAYS,
    LAST_30_DAYS,
    NEXT_7_DAYS,
    NEXT_30_DAYS,
    AVAILABLE_DATE_ATB_NOT_AVAILABLE,
    AVAILABLE_DATE_ATB_CURRENT,
    AVAILABLE_DATE_ATB_30_DAYS,
    AVAILABLE_DATE_ATB_60_DAYS,
    AVAILABLE_DATE_ATB_90_PLUS_DAYS,
    CUSTOM_DATE_RANGE,
    CUSTOM_DAYS_RANGE,
];

export const getCreditsFilterBarFilters = () => {
    return [
        {
            filterName: 'Credit number',
            filterStateName: 'CreditNumber',
            filterElement: 'input-autocomplete',
            filterQuery: 'GET_CREDITS_FOR_COMPANY_AUTOCOMPLETE_FILTER',
            filterSort: 'Credit number',
            filterResponse: 'GetCreditsForCompany.Credits',
            filterLabelField: 'Number',
        },
        {
            filterName: 'Customer',
            filterStateName: 'Customer',
            filterElement: 'input-autocomplete',
            filterQuery: 'GET_CUSTOMERS_FOR_COMPANY_AUTOCOMPLETE_FILTER',
            filterSort: 'Company name',
            filterResponse: 'GetCustomersForCompany.Customers',
            filterLabelField: 'DisplayName',
        },
        {
            filterName: 'Created since',
            filterStateName: 'CreatedDate',
            filterElement: 'select',
            filterType: 'text',
            filterMaxDate: moment(),
            filterOptions: creditsCreatedSinceOptions,
            filterOptionsCustomTypes: {
                'Custom date range': 'date-range',
                'Custom days range': 'all-days-range-from-to-last',
            },
            // offset: 1,
            // span: 5,
        },
        {
            filterName: 'Available since',
            filterStateName: 'AvailableDate',
            filterElement: 'select',
            filterType: 'text',
            filterOptions: creditsAvailableSinceOptions,
            filterOptionsCustomTypes: {
                'Custom date range': 'date-range',
                'Custom days range': 'all-days-range-from-to',
            },
            // span: 5,
        },
        {
            filterName: 'Amount',
            filterStateName: 'Amount',
            filterElement: 'select-multiple-and-input-amount',
            filterType: 'text',
            filterOptions: [
                {
                    AmountType: creditsAmountType,
                },
                {
                    AmountOperator: invoicesAmountOperatorOptions,
                },
            ],
        },
    ];
};

export const creditsStateFilterOptions = [
    { label: 'Open credits', value: 'Open' },
    { label: 'All credits', value: 'All' },
];

/**
 * For credit changes
 */

export const creditChangesFilters = {
    ALL_CHANGES: 'All changes',
};

export const creditChangesTableFilterOptions = [
    {
        label: 'All changes',
        value: creditChangesFilters.ALL_CHANGES,
    },
];

export const creditChangeTypes = {
    NewResource: 'NewResource',
    UpdatedResource: 'UpdatedResource',
    Allocation: 'Allocation',
    Deallocation: 'Deallocation',
};


export const creditsWidgetFilters = [
    {
        filterName: 'Customer',
        filterStateName: 'Customer',
        filterElement: 'input-autocomplete',
        filterQuery: 'GET_CUSTOMERS_FOR_COMPANY_AUTOCOMPLETE_FILTER',
        filterSort: 'Company name',
        filterResponse: 'GetCustomersForCompany.Customers',
        filterLabelField: 'DisplayName',
    },
    {
        filterName: 'Created since',
        filterStateName: 'CreatedDate',
        filterElement: 'select',
        filterType: 'text',
        filterMaxDate: moment(),
        filterOptions: creditsCreatedSinceOptions,
        filterOptionsCustomTypes: {
            'Custom date range': 'date-range',
            'Custom days range': 'all-days-range-from-to-last',
        },
    },
    {
        filterName: 'Available since',
        filterStateName: 'AvailableDate',
        filterElement: 'select',
        filterType: 'text',
        filterOptions: creditsAvailableSinceOptions,
        filterOptionsCustomTypes: {
            'Custom date range': 'date-range',
            'Custom days range': 'all-days-range-from-to',
        },
    },
    {
        filterName: 'Amount',
        filterStateName: 'Amount',
        filterElement: 'select-multiple-and-input-amount',
        filterType: 'text',
        filterOptions: [
            {
                AmountType: creditsAmountType,
                filterOptionName: 'AmountType',
                filterPlaceholder: 'Select Amount Type'
            },
            {
                amountOperator: invoicesAmountOperatorOptions,
                filterOptionName: 'AmountOperator',
                filterPlaceholder: 'Select Operator',
            },
        ],
    },
];